import { Button, Flex, Modal, Text } from '@driftt/dds'
import React from 'react'

import { CONFIRMATION_TEXT_COPIES as TEXT, PROMPT_MODES } from '../../constants'
import { PersonaFormAttributes } from '../types'
import { ListComponent } from './ListComponent'

interface ConfirmationModal {
  deleted: PersonaFormAttributes[]
  changed: PersonaFormAttributes[]
  aiMode?: keyof typeof PROMPT_MODES
  isOpen: boolean
  isNew?: boolean
  handleClose: () => void
  handleContinue: () => void
  isLoading: boolean
}

const ConfirmationModal = ({
  aiMode = PROMPT_MODES.MANUAL,
  isOpen = false,
  isLoading,
  changed,
  deleted,
  isNew,
  handleContinue,
  handleClose,
}: ConfirmationModal) => {
  const isSingular = changed.length + deleted.length === 1
  const title = TEXT[aiMode]
  const text = isSingular ? TEXT.singular : TEXT.plural

  return (
    <Modal.Root open={isOpen} onClose={handleClose}>
      <Modal.Dialog size="medium" variant="info">
        <Modal.Title title={title} />

        <Modal.Content scrollOverflow="inside">
          <Text>{text.description}</Text>

          <Flex gap={2} direction="column" css={{ padding: '$2 0' }}>
            <ListComponent
              changes={changed}
              title="Updated:"
              showTitle={!isNew}
            />
            <ListComponent
              changes={deleted}
              title="Removed:"
              showTitle={!isNew}
            />
          </Flex>

          <Text>{text.note}</Text>
        </Modal.Content>

        <Modal.Actions>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleContinue}
            loading={isLoading}
          >
            Yes, that’s correct
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default ConfirmationModal
